/* Print Phuket Business & Wholesale: sticky offsets, scroll reveal, sub-nav highlight, quote-type prefill. Content works without JS. */
(function(){
  var root=document.querySelector('.ppb');if(!root)return;

  // Keep sticky sub-nav (and sticky columns) below the site's sticky header
  var setTop=function(){
    var b=0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(e){
      if(getComputedStyle(e).position==='sticky'){var r=e.getBoundingClientRect();if(r.bottom>b&&r.top<=1+b)b=r.bottom;}
    });
    root.style.setProperty('--sticky',Math.max(0,Math.round(b))+'px');
  };
  setTop();window.addEventListener('resize',setTop,{passive:true});
  var st=false;window.addEventListener('scroll',function(){if(!st){st=true;requestAnimationFrame(function(){st=false;setTop();});}},{passive:true});

  // Quote type prefill: buttons with data-ppb-type, or ?type=wholesale|agency|custom|business
  var form=document.getElementById('ppb-quote-form');
  var setType=function(v){
    if(!form||!v)return;
    form.querySelectorAll('input[name="contact[Enquiry type]"]').forEach(function(r){if(r.value===v)r.checked=true;});
  };
  // In-page links: land below the sticky header + sub-nav (theme scroll handling ignores scroll-margin)
  var reduceM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var goTo=function(id,smooth){
    var t=document.getElementById(id);if(!t||!root.contains(t))return false;
    setTop();var sub=root.querySelector('.ppb-subnav');
    var off=(parseFloat(getComputedStyle(root).getPropertyValue('--sticky'))||0)+(sub?sub.offsetHeight:0)+16;
    var y=t.getBoundingClientRect().top+window.pageYOffset-off;
    window.scrollTo({top:Math.max(0,y),behavior:smooth&&!reduceM?'smooth':'auto'});return true;
  };
  root.addEventListener('click',function(e){
    var a=e.target.closest('[data-ppb-type]');if(a)setType(a.getAttribute('data-ppb-type'));
    var l=e.target.closest('a[href^="#"]');
    if(l&&l.getAttribute('href').length>1&&goTo(l.getAttribute('href').slice(1),true)){
      e.preventDefault();e.stopPropagation();
      try{history.replaceState(null,'',l.getAttribute('href'));}catch(err){}
    }
  },true);
  if(location.hash&&location.hash.length>1){
    var h=decodeURIComponent(location.hash.slice(1));
    if(h!=='ppb-quote-form')window.addEventListener('load',function(){setTimeout(function(){goTo(h,false);},60);});
  }
  var map={business:'Business printing',wholesale:'Wholesale or bulk',bulk:'Wholesale or bulk',agency:'Agency or reseller',reseller:'Agency or reseller',custom:'Custom project'};
  try{var t=new URLSearchParams(location.search).get('type');if(t&&map[t.toLowerCase()])setType(map[t.toLowerCase()]);}catch(err){}

  // After a successful submission, bring the confirmation into view and focus it
  var ok=root.querySelector('[data-ppb-ok]');
  if(ok){setTimeout(function(){ok.scrollIntoView({block:'center'});try{ok.focus({preventScroll:true});}catch(err){}},150);}
  if(form){form.addEventListener('submit',function(){var b=form.querySelector('[type=submit]');if(b){b.setAttribute('aria-busy','true');b.style.opacity='.7';}});}

  // 17 Oct 2026: embedded monday quote form. After a valid submit monday sends the form back to our site; the store refuses to be framed,
  // so the iframe just loads a second time. Second load = sent: show our own thank-you panel instead of the iframe.
  var qf=root.querySelector('[data-ppb-qf]'),qok=root.querySelector('[data-ppb-qf-ok]');
  if(qf&&qok){
    var fr=qf.querySelector('iframe'),n=0,t0=0;
    if(fr)fr.addEventListener('load',function(){
      if(fr.getAttribute('src')==='about:blank')return;
      n++;if(n===1){t0=Date.now();return;}
      if(Date.now()-t0>3000){
        try{(window.dataLayer=window.dataLayer||[]).push({event:'pp_quote_submit',type:'bulk',how:'business_page'});}catch(x){}
        fr.setAttribute('src','about:blank');
        window.postMessage({ppq:'sent'},location.origin);
      }
    });
  }

  // Sub-nav: highlight the section in view
  var links={};root.querySelectorAll('.ppb-subnav ul a').forEach(function(a){links[a.getAttribute('href').slice(1)]=a;});
  if('IntersectionObserver' in window){
    var cur=null;
    var so=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting&&links[e.target.id]){
        if(cur)cur.classList.remove('is-active');cur=links[e.target.id];cur.classList.add('is-active');
        var ul=cur.parentNode.parentNode;var l=cur.offsetLeft-ul.clientWidth/2+cur.clientWidth/2;
        if(ul.scrollWidth>ul.clientWidth)ul.scrollTo({left:l,behavior:'smooth'});
      }
    });},{rootMargin:'-45% 0px -50% 0px'});
    Object.keys(links).forEach(function(id){var s=document.getElementById(id);if(s)so.observe(s);});
    var first=document.getElementById('industries');
    window.addEventListener('scroll',function(){if(cur&&first&&first.getBoundingClientRect().top>window.innerHeight*.5){cur.classList.remove('is-active');cur=null;}},{passive:true});
  }

  // Reveal animations
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  root.classList.add('ppb-js');
  var els=root.querySelectorAll('[data-ppb-reveal],[data-ppb-steps]');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  els.forEach(function(el){io.observe(el);});
  if(ok)els.forEach(function(el){el.classList.add('is-in');});
  setTimeout(function(){els.forEach(function(el){el.classList.add('is-in');});},6000);
})();
